export const environment = {
	production: true,
  appKey: 'Grip_Prod',
	apiUrl: 'https://grip.lan.pwc.com/API.Gateway/api',
    applicationId: 3,
    auth: {
        authority: 'https://dev-247992.oktapreview.com/oauth2/default',
        client_id: '0oarf1up4rBz710WN0h7',
        redirect_uri: 'https://grip.lan.pwc.com/auth-callback',
        post_logout_redirect_uri: 'https://grip.lan.pwc.com/logout-callback',
      response_type: "code",
      scope: "openid profile email",
      filterProtocolClaims: true,
      loadUserInfo: false
    }
};
